import BaseService from 'services/base-service';
import { Common } from '../../src/utils/constants';
import { getPublicConfig } from 'services/payment/paymentConfig-service';
import { IConfiguration } from 'models/payment';
import { toast } from 'react-toastify';

export const getReferenceId = async () => {
  let reference = new Date().getFullYear().toString();
  reference += (new Date().getMonth() + 1 < 10 ? '0' : '').toString() + (new Date().getMonth() + 1).toString();
  reference += (new Date().getDate() < 10 ? '0' : '').toString() + new Date().getDate().toString();
  reference += (new Date().getHours() < 10 ? '0' : '').toString() + new Date().getHours().toString();
  reference += (new Date().getMinutes() < 10 ? '0' : '').toString() + new Date().getMinutes().toString();
  reference += (new Date().getSeconds() < 10 ? '0' : '').toString() + new Date().getSeconds().toString();

  const res = await BaseService({
    url: `/driver/detail`,
    method: 'POST',
    data: { platform_type: 'Web' },
  });
  if (res) {
    reference += `_${res.data.data.id.toString()}`;
  }
  return reference.toString();
};

export const CheckCard = (result) => {
  switch (result) {
    case Common.PaymentCardType.VISA.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.VISA,
        type: Common.PaymentCardType.VISA,
      };
    case Common.PaymentCardType.AMEX.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.AMEX,
        type: Common.PaymentCardType.AMEX,
      };
    case Common.PaymentCardType.DINERS_CLUB_CARTE_BLANCHE.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.DINERS_CLUB_CARTE_BLANCHE,
        type: Common.PaymentCardType.DINERS_CLUB_CARTE_BLANCHE,
      };
    case Common.PaymentCardType.DINERS_CLUB_INTERNATIONAL.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.DINERS_CLUB_INTERNATIONAL,
        type: Common.PaymentCardType.DINERS_CLUB_INTERNATIONAL,
      };
    case Common.PaymentCardType.JCB.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.JCB,
        type: Common.PaymentCardType.JCB,
      };
    case Common.PaymentCardType.LASER.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.LASER,
        type: Common.PaymentCardType.LASER,
      };
    case Common.PaymentCardType.VISA_ELECTRON.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.VISA_ELECTRON,
        type: Common.PaymentCardType.VISA_ELECTRON,
      };
    case Common.PaymentCardType.MASTERCARD.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.MASTERCARD,
        type: Common.PaymentCardType.MASTERCARD,
      };
    case Common.PaymentCardType.DISCOVER.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.DISCOVER,
        type: Common.PaymentCardType.DISCOVER,
      };
    case Common.PaymentCardType.DANKORT.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.DANKORT,
        type: Common.PaymentCardType.DANKORT,
      };
    case Common.PaymentCardType.MAESTRO.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.MAESTRO,
        type: Common.PaymentCardType.MAESTRO,
      };
    case Common.PaymentCardType.UATP.toLowerCase():
      return {
        cardImage: Common.PaymentCardTypeImage.UATP,
        type: Common.PaymentCardType.UATP,
      };
    default:
      return {
        cardImage: '',
        type: '',
      };
  }
};
export const getRoundupCharityByDonationValue = (actual_amount: number, donation_amount: number): number => {
  const fixedActualAmount = actual_amount.toFixed(2);
  const roundUpActualAmount = parseFloat(fixedActualAmount.split('.')[1]);
  const fixedDonationAmount = donation_amount.toFixed(2);
  const roundUpDonationAmount = parseFloat(fixedDonationAmount.split('.')[1]);
  if (!actual_amount) {
    return 0;
  }
  if (!roundUpActualAmount) {
    return 0;
  }
  if (!donation_amount) {
    return 0;
  }
  let finalRoundUpValue = '';
  if (roundUpActualAmount <= roundUpDonationAmount) {
    finalRoundUpValue = (roundUpDonationAmount - roundUpActualAmount).toString();
  } else {
    finalRoundUpValue = (100 - roundUpActualAmount).toString();
  }
  return parseFloat(`0.${finalRoundUpValue.padStart(2, '0')}`);
};

export const getDNAPaymentScript = (isTestMode: boolean): string => {
  return isTestMode
    ? 'https://test-pay.dnapayments.com/checkout/payment-api.js'
    : 'https://pay.dnapayments.com/checkout/payment-api.js';
};

export const getDNAPaymentScriptIntegrity = (isTestMode: boolean): string => {
  return isTestMode
    ? 'sha256-z27fIyoBGu/jlBtWNBta9k6bAfpIqeTuEVxceOXV53k='
    : 'sha256-A3y2uxmrya0WIZUTucuGnBjtT4PZ2+joczNt+ry+JOM=';
};

export const getDATATRANSPaymentScript = (isTestMode: boolean): string => {
  return isTestMode ? 'https://pay.sandbox.datatrans.com/v1/start' : 'https://pay.datatrans.com/v1/start';
};

export const getPublicConfigurationValue = async (configKey: string) => {
  let value;
  await getPublicConfig({ code: configKey })
    .then(async (res) => {
      value = res.data.find((x: IConfiguration) => x.reference_code === configKey).value;
    })
    .catch((m) => {
      if (m.response && m.response.data && m.response.data.message) {
        toast.error(m.response.data.message);
      } else {
        toast.error(m.toString());
      }
    });
  return value;
};
